import React, { useState } from "react";

const DEFAULT_VALUE = 10;
const DEFAULT_MIN_VALUE = 9;
const DEFAULT_MAX_VALUE = 15;

type TRangeInputProps = {
    defaultValue?: number;
    minValue?: number;
    maxValue?: number;
    minLabel?: React.ReactNode;
    maxLabel?: React.ReactNode;
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
};

const RangeInput = (props: TRangeInputProps) => {
    const [value, setValue] = useState(props.defaultValue || DEFAULT_VALUE);

    const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setValue(parseInt(event.target.value, 10));
        props.onChange(event);
    };

    return (
        <div>
            {props.minLabel || "a"}
            <input
                type="range"
                min={props.minValue || DEFAULT_MIN_VALUE}
                max={props.maxValue || DEFAULT_MAX_VALUE}
                value={value}
                onChange={onChange}
            />
            {props.maxLabel || "A"}
            <div style={{ textAlign: "center" }}>{value}</div>
        </div>
    );
};

export default RangeInput;
